import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["error", "className", "title", "help", "caption", "required", "placeholder", "defaultValue", "disabled"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import styles from "@/styles/Form.module.scss";
import classnames from "classnames";
import { forwardRef } from "react";
import ErrorMessage from "./ErrorMessage";
import { usePreventContextMenu } from "@/hooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var TextAreaField = /*#__PURE__*/forwardRef(function (props, ref) {
  var error = props.error,
      className = props.className,
      title = props.title,
      help = props.help,
      caption = props.caption,
      required = props.required,
      placeholder = props.placeholder,
      defaultValue = props.defaultValue,
      disabled = props.disabled,
      _props = _objectWithoutProperties(props, _excluded);

  var _usePreventContextMen = usePreventContextMenu(),
      _usePreventContextMen2 = _slicedToArray(_usePreventContextMen, 2),
      on = _usePreventContextMen2[0],
      off = _usePreventContextMen2[1];

  return /*#__PURE__*/_jsxs("div", {
    className: styles.inputField,
    children: [title && /*#__PURE__*/_jsx("legend", {
      className: classnames(styles.formTitle, _defineProperty({}, styles.required, required)),
      children: title
    }), help && /*#__PURE__*/_jsx("span", {
      className: styles.help,
      children: help
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.commentArea,
      children: [/*#__PURE__*/_jsx("textarea", _objectSpread({
        ref: ref,
        placeholder: placeholder,
        className: classnames(styles.textInput, className),
        defaultValue: defaultValue ? defaultValue : "",
        required: required,
        disabled: disabled,
        onFocus: off,
        onBlur: on
      }, _props)), error && /*#__PURE__*/_jsx(ErrorMessage, {
        msg: error
      }), caption && /*#__PURE__*/_jsx("p", {
        className: styles.textInputCaption,
        children: caption
      })]
    })]
  });
});
TextAreaField.displayName = "TextAreaField";
export default TextAreaField;